import { render, staticRenderFns } from "./quickSell.vue?vue&type=template&id=854c5e22&scoped=true"
import script from "./quickSell.vue?vue&type=script&lang=js"
export * from "./quickSell.vue?vue&type=script&lang=js"
import style0 from "./quickSell.vue?vue&type=style&index=0&id=854c5e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854c5e22",
  null
  
)

export default component.exports